import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastInfo, toastSuccess } from 'utils/toastify'
import { atenyaUser, errorMessage, loginTypeConst, LoginTypeConstObj } from 'constant/const'
import axiosInstance from 'utils/axiosConfig'

const initialState = {
   userData: null,
   loading: false,
   addChannel: false,
   addChannelData: null,
   isDashboard: false,
   addChannel504StatusError: false,
   loginType: null,
   instagramUser: null,
   instagramLoginError: false
}

export const loginAction = createAsyncThunk('user/loginAction', async (data) => {
   try {
      const response = await axiosInstance.post(`/user/login/`, data)
      // toastSuccess(response?.data?.message)
      if (response?.data?.data?.is_active) {
         return response?.data?.data
      } else {
         toastInfo(response?.data?.message)
         return response?.data?.data
      }
   } catch (error) {
      toastError(errorMessage)
      throw error.response ? error.response?.data?.message : error?.message
   }
})

export const readPrivacyPolicyAction = createAsyncThunk(
   'user/readPrivacyPolicyAction',
   async (data) => {
      try {
         const response = await axiosInstance.post(`/user/login/`, data)
         // toastSuccess(response?.data?.message)
         return response?.data?.data
      } catch (error) {
         toastError(errorMessage)
         throw error.response ? error.response?.data?.message : error?.message
      }
   }
)

export const addChannelAction = createAsyncThunk('user/addChannelAction', async (data) => {
   try {
      const response = await axiosInstance.post(`/yt/add_channel/`, data)
      // toastSuccess(response?.data?.message)
      return response?.data?.data
   } catch (error) {
      if (error.response?.status === 504) {
         return { is504Error: true }
         // toastError('Server is temporarily unavailable. Please try again later.')
      } else {
         toastError(errorMessage)
      }
      throw error.response ? error.response?.data?.message : error?.message
   }
})

export const onLogoutAction = createAsyncThunk('user/onLogoutAction', async (data) => {
   try {
      const response = await axiosInstance.post(`/user/logout/`, data)
      // toastSuccess(response?.data?.message)
      return response?.data?.data
   } catch (error) {
      toastError(errorMessage)
      throw error.response ? error.response?.data?.message : error?.message
   }
})

export const instagramLoginAction = createAsyncThunk('user/instagramLoginAction', async (data) => {
   try {
      const params = new URLSearchParams(data).toString()
      const response = await axiosInstance.get(`/instagram/callback/fetch_info/?${params}`)
      // toastSuccess(response?.data?.message)
      if (response?.data?.data?.is_active) {
         return response?.data?.data
      } else {
         toastInfo(response?.data?.message)
         return response?.data?.data
      }
   } catch (error) {
      toastError(errorMessage)
      throw error.response ? error.response?.data?.message : error?.message
   }
})

const AuthSlice = createSlice({
   name: 'user',
   initialState,
   reducers: {
      setUserDataLocal(state, action) {
         state.userData = action.payload
         localStorage.setItem(atenyaUser, JSON.stringify(action.payload))
      },
      logoutAction(state) {
         state.userData = null
         state.loginType = null
         localStorage.removeItem(atenyaUser)
         localStorage.removeItem(loginTypeConst)
      },
      resetAddChannel(state) {
         state.addChannel = false
      },
      resetAddChannelData(state) {
         state.addChannelData = null
      },
      setDashboardStatus(state, action) {
         state.isDashboard = action.payload
      },
      reset504Status(state) {
         state.addChannel504StatusError = false
      },
      setLoginType(state, action) {
         state.loginType = action.payload
         localStorage.setItem(loginTypeConst, action.payload)
      },
      resetInstagramLoginError(state) {
         state.instagramLoginError = false
      }
   },
   extraReducers: (builder) => {
      builder
         .addCase(loginAction.pending, (state) => {
            state.loading = true
            state.addChannel = false
         })
         .addCase(loginAction.fulfilled, (state, action) => {
            // if(action.payload?.is_privacy_checked){
            //    localStorage.setItem(atenyaUser, JSON.stringify(action.payload))
            // }
            if (action.payload?.is_active) {
               localStorage.setItem(atenyaUser, JSON.stringify(action.payload))
               state.userData = action.payload
            }
            state.loading = false
         })
         .addCase(loginAction.rejected, (state) => {
            state.loading = false
         })

         .addCase(readPrivacyPolicyAction.pending, (state) => {
            state.loading = true
            state.addChannel = false
         })
         .addCase(readPrivacyPolicyAction.fulfilled, (state, action) => {
            localStorage.setItem(atenyaUser, JSON.stringify(action.payload))
            state.userData = action.payload
            state.loading = false
         })
         .addCase(readPrivacyPolicyAction.rejected, (state) => {
            state.loading = false
         })

         .addCase(addChannelAction.pending, (state) => {
            state.loading = true
            state.addChannel = false
            state.addChannelData = null
            state.addChannel504StatusError = false
         })
         .addCase(addChannelAction.fulfilled, (state, action) => {
            // state.loading = false
            // state.addChannel = true
            // state.addChannelData = action.payload
            if (action.payload?.is504Error) {
               state.addChannel504StatusError = true
               state.loading = false
               state.addChannel = true
               state.addChannelData = null
            } else {
               state.addChannel504StatusError = false
               state.loading = false
               state.addChannel = true
               state.addChannelData = action.payload
            }
         })
         .addCase(addChannelAction.rejected, (state) => {
            state.loading = false
            state.addChannel = false
            state.addChannelData = null
         })
         .addCase(onLogoutAction.pending, (state) => {
            state.loading = true
         })
         .addCase(onLogoutAction.fulfilled, (state) => {
            state.loading = false
            state.userData = null
            localStorage.removeItem(atenyaUser)
            localStorage.removeItem(loginTypeConst)
            window.location.reload()
         })
         .addCase(onLogoutAction.rejected, (state) => {
            state.loading = false
            state.userData = null
            localStorage.removeItem(atenyaUser)
            window.location.reload()
         })
         .addCase(instagramLoginAction.pending, (state) => {
            state.loading = true
         })
         .addCase(instagramLoginAction.fulfilled, (state, action) => {
            state.loading = false
            localStorage.setItem(atenyaUser, JSON.stringify(action.payload))
            state.userData = action.payload
            state.loginType = LoginTypeConstObj.instagram
            state.instagramLoginError = false
            localStorage.setItem(loginTypeConst, LoginTypeConstObj.instagram)
         })
         .addCase(instagramLoginAction.rejected, (state) => {
            state.loading = false
            state.userData = null
            state.instagramLoginError = true
         })
   }
})

export const {
   setUserDataLocal,
   logoutAction,
   resetAddChannel,
   resetAddChannelData,
   setDashboardStatus,
   reset504Status,
   setLoginType,
   resetInstagramLoginError
} = AuthSlice.actions
export default AuthSlice.reducer
